module.exports = __webpack_public_path__ + "static/owlbear2-14c53b65a49d3ee90a6945a202e3da08.jpg";